/*
  PWR Article page — copy-link share action only. Vanilla JS, no dependency.
  Facebook/X/WhatsApp share buttons are plain links and need no JS.
*/
(function () {
  var button = document.querySelector('[data-pwr-copy-link]');
  if (!button) return;

  var message = document.querySelector('[data-pwr-copy-message]');

  button.addEventListener('click', function () {
    var url = button.getAttribute('data-url');
    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(function () {
      if (!message) return;
      message.textContent = 'Link copied';
      message.classList.remove('visually-hidden');
      window.setTimeout(function () {
        message.classList.add('visually-hidden');
      }, 2000);
    });
  });
})();
